export default __webpack_public_path__ + "static/media/POSTER 3.6fd7b8b1.JPG";